"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ILStudentList = void 0;
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var common_components_1 = require("../event-timeoff-form/common.components");
var il_icon_common_1 = require("../il-icon/il-icon.common");
var solid_icon_definitions_1 = require("../il-icon/solid-icon-definitions");
var enums_1 = require("../../shared/enums");
function SecondaryAction(_a) {
    var isStudentSelected = _a.isStudentSelected;
    return (react_1.default.createElement(material_1.IconButton, { edge: "end", "aria-label": "comments" },
        react_1.default.createElement(il_icon_common_1.SolidIcon, { icon: solid_icon_definitions_1.SolidIconDefinitions.CHEVRON_RIGHT, sx: {
                color: isStudentSelected ? 'primary.main' : 'text.secondary',
            }, size: enums_1.IconSizeEnum.SMALL })));
}
function ILStudentList(_a) {
    var students = _a.students, showChevrons = _a.showChevrons, showDividers = _a.showDividers, onSelectStudent = _a.onSelectStudent, selected = _a.selected, sx = _a.sx, className = _a.className, _b = _a.title, title = _b === void 0 ? 'Student' : _b, header = _a.header, _c = _a.emptyText, emptyText = _c === void 0 ? react_1.default.createElement(material_1.Typography, { variant: enums_1.TypographyVariantEnum.BODY1 }, "No Active Students") : _c, children = _a.children;
    var theme = (0, material_1.useTheme)();
    return (react_1.default.createElement(material_1.Box, { className: 'il-student-list ' + className, sx: __assign({ display: 'flex', flexDirection: 'column', gap: '.5rem' }, sx) },
        header && (react_1.default.createElement(material_1.Typography, { variant: enums_1.TypographyVariantEnum.H3, sx: { mb: '1rem', width: '100%', textAlign: 'center' } }, header)),
        react_1.default.createElement(material_1.Typography, { variant: enums_1.TypographyVariantEnum.BODY1, sx: { fontSize: '.9375rem', color: 'text.secondary', fontWeight: 'bold' } }, title),
        react_1.default.createElement(material_1.List, { dense: true, sx: { my: 0, pt: 0 } },
            (!students || !(students === null || students === void 0 ? void 0 : students.length)) && (react_1.default.createElement(material_1.ListItem, { disablePadding: true, "aria-label": "menuitem empty" }, emptyText)), students === null || students === void 0 ? void 0 :
            students.map(function (student, idx) {
                var isStudentSelected = (selected === null || selected === void 0 ? void 0 : selected.guid) === student.guid;
                return (react_1.default.createElement(react_1.default.Fragment, { key: student.guid },
                    react_1.default.createElement(material_1.ListItem, __assign({ disablePadding: true, "aria-label": "menuitem ".concat(student.firstName) }, (showChevrons && {
                        secondaryAction: react_1.default.createElement(SecondaryAction, { isStudentSelected: isStudentSelected }),
                    })),
                        react_1.default.createElement(material_1.ListItemButton, { onClick: function () { return onSelectStudent(student); }, selected: isStudentSelected, sx: {
                                color: isStudentSelected ? 'primary.main' : 'text.primary',
                                '& .MuiListItemText-root .MuiTypography-root': {
                                    fontSize: '1rem',
                                },
                                '& .MuiAvatar-root': {
                                    width: '1.5rem',
                                    height: '1.5rem',
                                },
                                '& .MuiListItemAvatar-root': {
                                    minWidth: '2rem',
                                },
                                px: '0.5rem',
                                '&:hover': {
                                    background: 'transparent',
                                },
                            }, component: 'div' },
                            react_1.default.createElement(common_components_1.RenderStudentItem, { student: __assign(__assign({}, student), { avatar: isStudentSelected ? theme.palette.primary.main : student.avatar }) }))),
                    students[idx + 1] !== undefined && showDividers ? react_1.default.createElement(material_1.Divider, null) : null));
            })),
        children));
}
exports.ILStudentList = ILStudentList;
